import { render, staticRenderFns } from "./SchoolTeacherDetail.vue?vue&type=template&id=32cef287&scoped=true"
import script from "./SchoolTeacherDetail.vue?vue&type=script&lang=js"
export * from "./SchoolTeacherDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolTeacherDetail.vue?vue&type=style&index=0&id=32cef287&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cef287",
  null
  
)

export default component.exports